// Re-export shim — the implementation has been moved to
// ./CollectableCoupon/FloatingCollectableCoupon. This file preserves
// the existing import path (`@/components/FloatingCollectableCoupon`).
export { default } from './CollectableCoupon/FloatingCollectableCoupon';
